export enum ROLES {
  COMMERCIAL = 'COMMERCIAL',
  ENGINEERING_NETWORKS = 'ENGINEERING_NETWORKS',
  FURNISHING_SUPERVISOR = 'FURNISHING_SUPERVISOR',
  HEAD_EN = 'HEAD_EN',
  HEAD_OVP = 'HEAD_OVP',
  OBSERVER = 'OBSERVER',
  PARTNER = 'PARTNER',
  PLANNER = 'PLANNER',
  PRIME_CONTRACTOR = 'PRIME_CONTRACTOR',
  HOUSING_CONTRACTOR = 'HOUSING_CONTRACTOR',
  USK_PRE_ACCEPTANCE = 'USK_PRE_ACCEPTANCE',
  SUPERVISOR = 'SUPERVISOR',
  UNSET = 'UNSET',
}
